import { render, staticRenderFns } from "./TelForm.vue?vue&type=template&id=cb179da0&"
import script from "./TelForm.vue?vue&type=script&lang=ts&"
export * from "./TelForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports